<template>
    <v-app :data-theme="themeVariant">
        <AppBar />
        <v-main class="main-container">
            <CodeMatrixBackground />
            <NeuralWaveBackground />
            <AppLoader />
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import AppBar from '@/components/layout/AppBar.vue';
import AppLoader from '@/components/layout/AppLoader.vue';
import CodeMatrixBackground from '@/components/layout/CodeMatrixBackground.vue';
import NeuralWaveBackground from '@/components/layout/NeuralWaveBackground.vue';
import { themeVariant } from '@/composables/useThemeVariant';

export default {
    name: 'App',
    components: { AppBar, AppLoader, CodeMatrixBackground, NeuralWaveBackground },
    // Exposed as [data-theme] for the effects of a variant that aren't colors.
    setup: () => ({ themeVariant }),
};
</script>

<style scoped>
.main-container {
    background: linear-gradient(to right, var(--v-backdrop-start-base), var(--v-backdrop-end-base));
}
</style>
